import { useLocation, useNavigate } from "react-router-dom";
import {
  LogoIcon,
  DashboardIcon,
  HomeIcon,
  LibraryIcon,
  AccountsIcon,
  PoolsIcon,
} from "./icons";
import { useTranslation } from "react-i18next";
import { Tooltip } from "../tooltip";
import { useStyles } from "./style";
import { Box } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth0 } from "@auth0/auth0-react";

export const SidebarMenu = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Box className={classes.container}>
      <Box>
        <Box className={classes.apaLogoWrapper}>
          <LogoIcon width={32} height={52} />
        </Box>

        <Box className={classes.drawerButton}>
          <Tooltip title={t("dashboard.title")}>
            <Box className={classes.iconWrapper} onClick={() => navigate("/")}>
              <DashboardIcon
                width={28}
                height={28}
                active={location.pathname === "/"}
              />
            </Box>
          </Tooltip>
          <Tooltip title={t("home.title")}>
            <Box
              className={classes.iconWrapper}
              onClick={() => navigate("/home")}
            >
              <HomeIcon
                width={28}
                height={28}
                active={location.pathname === "/home"}
              />
            </Box>
          </Tooltip>
          <Tooltip title={t("videoLibrary.title")}>
            <Box
              className={classes.iconWrapper}
              onClick={() => navigate("/video-library")}
            >
              <LibraryIcon
                width={28}
                height={28}
                active={location.pathname.startsWith("/video-library")}
              />
            </Box>
          </Tooltip>
          <Tooltip title={t("poolsManagement.title")}>
            <Box
              className={classes.iconWrapper}
              onClick={() => navigate("/pools-management")}
            >
              <PoolsIcon
                width={28}
                height={28}
                active={location.pathname === "/pools-management"}
              />
            </Box>
          </Tooltip>
          <Tooltip title={t("accountManagement.title")}>
            <Box
              className={classes.iconWrapper}
              onClick={() => navigate("/accounts")}
            >
              <AccountsIcon
                width={28}
                height={28}
                active={location.pathname === "/accounts"}
              />
            </Box>
          </Tooltip>
        </Box>
      </Box>

      <Box className={classes.bottomIcons}>
        <Box
          component="button"
          type="button"
          className={classes.logoutButton}
          onClick={handleLogout}
          aria-label="Logout"
        >
          <LogoutIcon className={classes.logoutIcon} />
          <span>Logout</span>
        </Box>
      </Box>
    </Box>
  );
};
